export default "__VITE_ASSET__8cc928f9__"